import { Form, Field, TextInput, useFormState } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { formatQuantityOrDash } from '@/lib/format/number';
import { declarationValidation } from '../../declarationsValidation';
import { useDeclarationQuantityColumns } from '../../hooks';

const NOOP = () => {};

/**
 * Props:
 *   materials  the account's materials (useValidateDeclarationFormOptions().materials)
 */
export const ValidateDeclarationQuantityFields = ({ materials }) => {
  const t = useTranslations();
  const { values } = useFormState();

  const { declarationUnit, workingUnit, trackingUnit, columns } = useDeclarationQuantityColumns({
    materials,
    materialId: values.materialId,
    quantity: values.quantity,
  });

  return (
    <Form.Section title={t('SECTION_QUANTITY')}>
      <Form.Row columns={2}>
        <Field name="quantity" required rules={declarationValidation.quantity}>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <TextInput
              id={id}
              name={name}
              label={t('FIELD_QUANTITY')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
            />
          )}
        </Field>

        <TextInput label={t('FIELD_UNIT')} value={declarationUnit} onChange={NOOP} disabled />
      </Form.Row>

      {workingUnit || trackingUnit ? (
        <Form.Row columns={2}>
          {workingUnit ? (
            <TextInput
              label={t('SECTION_QUANTITY_IN_UNIT', { unit: workingUnit })}
              value={formatQuantityOrDash(columns.workingQuantity, workingUnit)}
              onChange={NOOP}
              disabled
            />
          ) : null}
          {trackingUnit ? (
            <TextInput
              label={t('SECTION_QUANTITY_IN_UNIT', { unit: trackingUnit })}
              value={formatQuantityOrDash(columns.trackingQuantity, trackingUnit)}
              onChange={NOOP}
              disabled
            />
          ) : null}
        </Form.Row>
      ) : null}
    </Form.Section>
  );
};
